import { render, staticRenderFns } from "./MarkNotRelevantModal.vue?vue&type=template&id=bc9e09f2&scoped=true"
import script from "./MarkNotRelevantModal.vue?vue&type=script&lang=js"
export * from "./MarkNotRelevantModal.vue?vue&type=script&lang=js"
import style0 from "./MarkNotRelevantModal.vue?vue&type=style&index=0&id=bc9e09f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9e09f2",
  null
  
)

export default component.exports